export default "__VITE_ASSET___9GV_CEk__"